import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

function addDishToCart(dish, maxCount, cartItems) {
  const containingCartItem = cartItems.filter(cartItem => cartItem.dish.id === dish.id)
    .pop();
  if (containingCartItem) {
    const newCount = containingCartItem.count + 1;

    if (!maxCount || newCount <= maxCount) {
      return [
        ...cartItems.slice(0, cartItems.indexOf(containingCartItem)),
        { ...containingCartItem, count: newCount },
        ...cartItems.slice(cartItems.indexOf(containingCartItem) + 1)
      ];
    }
    else {
      return  cartItems;
    }
  }
  return [...cartItems, {dish, count: 1}];
}

function removeDishFromCart(dish, minCount, cartItems) {
  const containingCartItem = cartItems.filter(cartItem => cartItem.dish.id === dish.id)
    .pop();

  if (!containingCartItem) {
    return cartItems;
  }

  const newCount = containingCartItem.count - 1;

  if (minCount < 0 && newCount <= 0) {
    //remove cartItem
    return [
      ...cartItems.slice(0, cartItems.indexOf(containingCartItem)),
      ...cartItems.slice(cartItems.indexOf(containingCartItem) + 1)
    ];
  }
  else if (newCount >= minCount) {
    //keep cartItem
    return [
      ...cartItems.slice(0, cartItems.indexOf(containingCartItem)),
      { ...containingCartItem, count: newCount},
      ...cartItems.slice(cartItems.indexOf(containingCartItem) + 1)
    ];
  }
  return cartItems;
}

export default function cartReducer(state = initialState.cart, action) {
  switch (action.type) {
    case actionTypes.CART_ADD_DISH:
    case actionTypes.CART_INCREASE_DISH_COUNT:
      return {
        ...state,
        cartItems: addDishToCart(action.dish, action.maxCount, state.cartItems)
      };
    case actionTypes.CART_DECREASE_DISH_COUNT:
      return {
        ...state,
        cartItems: removeDishFromCart(action.dish, action.minCount, state.cartItems)
      };
    case actionTypes.CART_CLEAN:
      return {...initialState.cart};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js